import { Injectable } from '@angular/core';
import { Observable, delay, map, of } from 'rxjs';
import { RequesterService, ErrorService } from '@upassignations/core';
import { ViewClass } from '@upassignations/feature';
import { ViewClass as CoreViewClass } from '@upassignations/core';
import { CustomAppConfig } from '@upassignations/custom-app-config';
import {
  MOCK_LITIGATIONS_1,
  MOCK_LITIGATIONS_2,
} from '@upassignations/feature';
@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  constructor(
    // eslint-disable-next-line no-unused-vars
    private config: CustomAppConfig,
    // eslint-disable-next-line no-unused-vars
    private requesterService: RequesterService,
    // eslint-disable-next-line no-unused-vars
    private errorService: ErrorService
  ) {}

  getUserProfile$(): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', CoreViewClass.GET_USER_PROFILE);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }

  getListOfLitigation$(dateOfLastModificationMin?: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.GET_LIST_OF_LITIGATIONS);

    if (dateOfLastModificationMin !== undefined) {
      data.append('dateOfLastModificationMin', dateOfLastModificationMin);
    }

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          // console.log(response);
          this.handleError(response);
          return response;
        })
      );
  }

  getArchivedLitigation$(): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.GET_ARCHIVED_LITIGATIONS);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }

  getLitigationMetadata$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.DISPLAY_LITIGATION_METADATA);
    data.append('litigation', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);

          return response.metadata;
        })
      );
  }
  getLogMetadata$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.DISPLAY_LOG_METADATA);
    data.append('log', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);

          return response.metadata;
        })
      );
  }

  getActionsHistory$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.ACTIONS_HISTORY_LIST);
    data.append('litigation', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response.actions;
        })
      );
  }

  assignLitigation$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.ASSIGN_LITIGATION);
    data.append('litigation', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }

  deassignLitigation$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.DEASSIGN_LITIGATION);
    data.append('litigation', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }

  exportLitigation$(litigationUris: string[]): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.EXPORT_LITIGATIONS);
    data.append('litigations', JSON.stringify(litigationUris));
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  exportLogs$(logsUris: string[]): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.EXPORT_LOGS);
    data.append('log', JSON.stringify(logsUris));
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  downloadExportedFileFromServer(fileName: string): Observable<any> {
    return this.requesterService
      .httpGettingSynchronously$(
        this.config.get('apiEndpoint') + '/storage/file?fileName=' + fileName,
        { responseType: 'blob' },
        true
      )
      .pipe(
        map((response) => {
          this.handleError(response);
          return response;
        })
      );
  }
  deactivateLitigation$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.DEACTIVATE_LITIGATION);
    data.append('litigation', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  reactivateLitigation$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.REACTIVATE_LITIGATION);
    data.append('litigation', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }

  getListOfTopics$(): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.LIST_OF_TOPICS);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  updateTopic$(litigationUri: string, topicUri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.UPDATE_TOPIC);
    data.append('litigation', litigationUri);
    data.append('topic', topicUri);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  getListOfEntities$(): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.LIST_OF_ENTITIES);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  updateResponsibleEntity$(
    litigationUri: string,
    entityUri: string
  ): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.UPDATE_RESPONSIBLE_ENTITY);
    data.append('litigation', litigationUri);
    data.append('entity', entityUri);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  getListOfProceduralActs$(): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.LIST_OF_PROCEDURAL_ACTS);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  updateProceduralAct$(
    litigationUri: string,
    proceduralActUri: string
  ): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.UPDATE_PROCEDURAL_ACT);
    data.append('litigation', litigationUri);
    data.append('proceduralAct', proceduralActUri);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  reportIssue$(uri: string, message: string, subject: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.REPORT_ISSUE);
    data.append('litigation', uri);
    data.append('message', message);
    data.append('subject', subject);

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  excludeLitigationFromGroup$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.EXCLUDE_LITIGATION_FROM_GROUP);
    data.append('litigation', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  unarchiveLitigation$(uri: string): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.UNARCHIVE_LITIGATION);
    data.append('litigation', uri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }

  getListOfLogs$(pageNumber?: number, pageSize?: number): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.LIST_OF_LOGS);

    if (pageNumber !== undefined) {
      data.append('pageNumber', pageNumber.toString());
    }

    if (pageSize !== undefined) {
      data.append('pageSize', pageSize.toString());
    }

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  getListOfUnauthorizedFeatures$(
    rootService: string,
    recursively: boolean
  ): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', CoreViewClass.GET_DEACTIVATED_SERVICES_FOR_USER);
    data.append('rootService ', rootService);
    data.append('recursively ', recursively.toString());

    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response.deactivatedServices;
        })
      );
  }
  downloadLitigationDocument$(litigationUri): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.DOWNLOAD_LITIGATION_DOCUMENT);
    data.append('litigation', litigationUri);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }
  downloadUserGuide$(): Observable<any> {
    const data = new FormData();
    data.append('_viewClass', ViewClass.DOWNLOAD_USER_GUIDE);
    return this.requesterService
      .httpPostingSynchronously$(
        `${this.config.get('apiEndpoint')}/api/execute`,
        data
      )
      .pipe(
        map((response: any) => {
          this.handleError(response);
          return response;
        })
      );
  }

  handleError(response: any): void {
    if (response?.error) {
      console.log('error');

      this.errorService.setError(response.error.code, response.error.message);
    }
  }
}
